import { apiFetchWithRetry } from "../lib/request";

export async function fetchWebsiteSettings() {
  const json = await apiFetchWithRetry("/website", { method: "GET" });
  return json?.result || json;
}

export async function updateWebsiteSettings(settings) {
  const json = await apiFetchWithRetry("/website", {
    method: "POST",
    body: JSON.stringify(settings),
  });
  return json?.result || json;
}
